export const styles = {
  container: 'tw-flex tw-flex-col tw-gap-4',
  header: 'tw-flex tw-items-center tw-justify-between',
  description: 'tw-text-sm tw-font-medium tw-text-neutral-700',
};
